import { render, staticRenderFns } from "./LiveStreaming.vue?vue&type=template&id=247e3f1c&scoped=true"
import script from "./LiveStreaming.vue?vue&type=script&lang=js"
export * from "./LiveStreaming.vue?vue&type=script&lang=js"
import style0 from "./LiveStreaming.vue?vue&type=style&index=0&id=247e3f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247e3f1c",
  null
  
)

export default component.exports